import { Injectable, Inject } from '@angular/core';
import { GridDataService } from './core/griddata.service';
import { AttributeService } from '../odata-services';
import { NotificationService } from '@progress/kendo-angular-notification';

@Injectable({
  providedIn: 'root'
})
export class AttributeDataService extends GridDataService {
    
  public odataService: AttributeService;
  
  
    constructor( @Inject(AttributeService) service: AttributeService, @Inject(NotificationService) notificationService?: NotificationService) { 
      super(service,null,notificationService); 
      this.odataService = service;
    }
}
